import * as React from "react";

import { useTable } from "react-table";

import ClassNames from "classnames";
import Typography from "../Typography";
import Styles from "./Table.module.css";

export interface Header {
  Header: string;
  accessor: string;
}
export interface Props {
  children?: any;
  className?: string;
  columnHeaders: Header[];
  rowsData: object[];
}

const Table: React.FC<Props> = props => {
  const { columnHeaders = [], rowsData = [], className } = props;

  const data = React.useMemo(() => rowsData, []);

  const columns = React.useMemo(() => columnHeaders, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({ columns, data });

  return (
    <table
      {...getTableProps()}
      className={
        ClassNames({
          [Styles.table]: true,
          [className]: className
        }) || undefined
      }
    >
      <thead>
        {headerGroups.map((headerGroup, index) => {
          return (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              key={index}
              className={Styles.row}
            >
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps()}
                  key={column.id}
                  className={Styles.headerCell}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          );
        })}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map(row => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} key={row.id} className={Styles.row}>
              {row.cells.map(cell => {
                return (
                  <td
                    {...cell.getCellProps()}
                    key={cell.column.id}
                    className={Styles.bodyCell}
                  >
                    <Typography noTopMargin>{cell.render("Cell")}</Typography>
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Table;
